import { HttpGet } from "../utils/request";

export function qu100Data(date, top, frequency) {
     return HttpGet(`/api/v3/mf100?date=${date}&top=${top}&frequency=${frequency}`)
}